
 export interface DataType {
  id: number,
  name: string,
  userId: number,
  status: number | string,
  activityId: number,
  cancellationTime: string,
  cancellationNote: string,
  cpsChannelId: string,
  cpsType: number,
  refundAmount: number,
  afterSaleType: number,
  afterSaleTime: string,
  afterSaleRemark: string,
  mobile: string,
  createTime: string,
  supplyChannelId: number,
  supplyChannelName: string,
  customerOrderNo: string,
  orderId: string,
  mallOrderFinishTime: string,
}

export interface ExpandedDataType  extends DataType{
  uniqueId: string,
  userActivityCycleId: string,
  activityCycleId: string,
  productId: number,
  productName: string,
  mallOrderNo:string,
  mallOrderStatus: number,
  mallOrderStatusTxt: string,
  isCurrentCycle:boolean
  collectionAccount: string,
}

export const column = (filed:string='') => {
  return [
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
      width: 150,
    },
    {
      title: '下单时间',
      dataIndex: filed,
      key: filed,
    },
    {
      title: '领取状态',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (status: number) => {
        return status == 1 ? '进行中' : status == 2 ? '已结束' : status == 3 ? '已作废' : ''; 
      }
    },
    {
      title: '权益',
      dataIndex: 'productName',
      key: 'productName',
      width: 130,
    },
    {
      title: '供货渠道',
      dataIndex: 'supplyChannelName',
      key: 'supplyChannelName',
      width: 100,
    },
    {
      title: '手机号',
      dataIndex: 'mobile',
      key: 'mobile',
      width: 100,
    },
    {
      title: '主订单号',
      dataIndex: 'orderId',
      key: 'orderId',
      width: 160,
    },
  ];
}